export const maxLength = (max) => (value) => !!value && value.length > max;

export const minLength = (min) => (value) => !!value && value.length < min;
